const escapeMap: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#039;",
};

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (character) => escapeMap[character]);
}

export function renderMarkdown(markdown: string): string {
  const blocks = markdown.trim().split(/\n{2,}/);
  return blocks
    .map((block) => {
      const value = escapeHtml(block.trim());
      if (value.startsWith("### ")) return `<h3>${inline(value.slice(4))}</h3>`;
      if (value.startsWith("## ")) return `<h2>${inline(value.slice(3))}</h2>`;
      if (value.startsWith("# ")) return `<h1>${inline(value.slice(2))}</h1>`;
      return `<p>${inline(value).replaceAll("\n", "<br>")}</p>`;
    })
    .join("");
}

function inline(value: string): string {
  return value
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/\*([^*]+)\*/g, "<em>$1</em>");
}
